export const bugReportURL = new URL(
  'https://issues.amazon.com/issues/create?template=867d38fd-0b5e-4502-8d4a-6ee9c2c74de6'
);
